var render = function render(){var _vm=this,_c=_vm._self._c;return _c('attribute-popover-base',{ref:"base",attrs:{"bindings":_vm.bindings,"disabled":_vm.disabled}},[_vm._t("default"),_vm._v(" "),_c('keen-referral-source-picker',{attrs:{"slot":"controls","disabled":_vm.isSaving},slot:"controls",model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }